/*
  Bonny & Rose: de maattabel naast het woord "Size" zetten.

  Het thema levert de maatkeuze en de maattabel als twee losse blokken, dus de
  link belandde onder de maatknoppen. Daar staat hij te ver van de vraag die hij
  beantwoordt: welke maat neem ik.

  Met opmaak alleen lukt het niet — het woord "Size" zit ín het keuzeblok en de
  link erbuiten, en hoe hoog dat woord staat hangt af van hoeveel kleuren het
  product heeft. Daarom wordt de link hier eenmalig naast het label gehangen.

  Gebeurt er niets (geen maattabel, geen label), dan blijft alles staan zoals
  het stond.
*/
(function () {
  'use strict';

  function verplaats() {
    var tabel = document.querySelector('.size-chart__standalone');
    if (!tabel) return;

    var labels = document.querySelectorAll('.variant-wrapper .variant__label');
    var label = null;
    for (var i = 0; i < labels.length; i++) {
      if (/^\s*size/i.test(labels[i].textContent)) {
        label = labels[i];
        break;
      }
    }
    if (!label) return;

    /* Al gedaan: niets opnieuw verplaatsen, anders schuift hij bij elke
       kleurwissel weer een niveau dieper. */
    if (label.parentNode.classList.contains('br-size-head')) return;

    var kop = document.createElement('div');
    kop.className = 'br-size-head';
    label.parentNode.insertBefore(kop, label);
    kop.appendChild(label);
    kop.appendChild(tabel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', verplaats);
  } else {
    verplaats();
  }

  /* Bij een kleurwissel haalt het thema de productsectie opnieuw op en zet die
     in de plaats van de oude. Alles wat hierboven aan de pagina is gehangen is
     dan weg, dus dit moet daarna opnieuw. De sectie meldt dat zelf met
     shopify:section:load. */
  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(verplaats, 0);
  });

})();
